import React from 'react';
function DesignSwitch({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M5 16.4444H19M19 16.4444L15.5 12.8889M19 16.4444L15.5 20M19 7.55556H5M5 7.55556L8.5 4M5 7.55556L8.5 11.1111"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default DesignSwitch;
